/**
 * Отменённый запрос (уход со страницы, более новый запрос, таймаут) — штатный
 * ход дел, а не ошибка. `controller.abort()` без причины даёт AbortError
 * «signal is aborted without reason»; он не должен попадать в трекер ошибок
 * и в «Произошла ошибка». Настоящие ошибки по-прежнему доходят.
 */
export const ABORT_REASON = {
    timeout: 'request timed out',
    unmount: 'component unmounted',
    superseded: 'superseded by a newer request',
}

/** Причина отмены для `controller.abort(reason)` — AbortError с понятным текстом. */
export function abortReason(message) {
    return new DOMException(message, 'AbortError')
}

export function isExpectedAbort(err) {
    if (!err) return false
    return err.name === 'AbortError'
}

/** Решение для Sentry.beforeSend: true — событие отбросить. */
export function shouldDropSentryEvent(event, hint) {
    if (isExpectedAbort(hint?.originalException)) return true
    const values = event?.exception?.values
    if (Array.isArray(values)) {
        return values.some((v) => v?.type === 'AbortError'
            || (typeof v?.value === 'string' && /signal is aborted without reason/i.test(v.value)))
    }
    return false
}
